import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, sessao, FLUXO, ST_LABEL, ST_COR } from '../api';
import { Icone } from '../Icones.jsx';

export default function Ordens() {
  const u = sessao.usuario;
  const [lista, setLista] = useState([]);
  const [lojas, setLojas] = useState([]);
  const [diasAtraso, setDiasAtraso] = useState(5);
  useEffect(() => { api('/config').then(c => setDiasAtraso(c.dias_atraso)).catch(() => {}); }, []);
  const [sp] = useSearchParams();
  const [f, setF] = useState({
    loja_id: sp.get('loja_id') || '', status: sp.get('status') || '', busca: '',
    divergencia: sp.get('divergencia') || '', caixa: '', atrasadas: sp.get('atrasadas') || '', canceladas: '',
  });

  const carregar = () => {
    const q = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
    api(`/ordens${q ? '?' + q : ''}`).then(setLista).catch(() => {});
  };
  useEffect(() => { carregar(); }, [f.loja_id, f.status, f.divergencia]);
  useEffect(() => { if (u.perfil !== 'atendente' || !u.loja_id) api('/lojas').then(setLojas).catch(() => {}); }, []);

  return (
    <div>
      <h2 style={{ marginBottom: 14 }}>Ordens de Serviço</h2>
      <div className="card">
        <div className="row" style={{ marginBottom: 12 }}>
          <input className="input" style={{ flex: 1, minWidth: 180 }} placeholder="Buscar por cliente, nº OS ou nº pedido…"
            value={f.busca} onChange={e => setF({ ...f, busca: e.target.value })}
            onKeyDown={e => e.key === 'Enter' && carregar()} />
          {(u.perfil !== 'atendente' || !u.loja_id) && (
            <select className="select" style={{ width: 200 }} value={f.loja_id} onChange={e => setF({ ...f, loja_id: e.target.value })}>
              <option value="">Todas as lojas</option>
              {lojas.map(l => <option key={l.id} value={l.id}>{l.nome}</option>)}
            </select>
          )}
          <select className="select" style={{ width: 180 }} value={f.status} onChange={e => setF({ ...f, status: e.target.value })}>
            <option value="">Todos os status</option>
            {FLUXO.map(s => <option key={s} value={s}>{ST_LABEL[s]}</option>)}
          </select>
          <input className="input" style={{ width: 90 }} placeholder="Caixa"
            value={f.caixa} onChange={e => setF({ ...f, caixa: e.target.value })}
            onKeyDown={e => e.key === 'Enter' && carregar()} />
          <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 13, cursor: 'pointer' }}>
            <input type="checkbox" checked={f.atrasadas === '1'}
              onChange={e => setF({ ...f, atrasadas: e.target.checked ? '1' : '' })}
              style={{ accentColor: 'var(--vermelho)' }} />
            Atrasadas
          </label>
          <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 13, cursor: 'pointer' }}>
            <input type="checkbox" checked={f.canceladas === '1'}
              onChange={e => setF({ ...f, canceladas: e.target.checked ? '1' : '' })}
              style={{ accentColor: 'var(--cinza)' }} />
            Canceladas
          </label>
          <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 13, cursor: 'pointer' }}>
            <input type="checkbox" checked={f.divergencia === '1'}
              onChange={e => setF({ ...f, divergencia: e.target.checked ? '1' : '' })}
              style={{ accentColor: 'var(--vermelho)' }} />
            Com divergência
          </label>
          <button className="btn-sec" onClick={carregar}>Buscar</button>
        </div>

        <table className="tbl">
          <thead>
            <tr><th>OS</th><th>Cliente</th><th>Loja</th><th>Vendedor(a)</th><th>Lente</th>{u.perfil !== 'atendente' && <th>Pedido</th>}<th>Caixa</th><th>Status</th><th>Dias</th></tr>
          </thead>
          <tbody>
            {lista.map(o => (
              <tr key={o.id}>
                <td>
                  <Link to={`/ordens/${o.id}`} style={{ fontWeight: 800, color: 'var(--verde)' }}>{o.numero_os}</Link>
                  {o.perdas > 0 && <span title={`Perda na montagem (${o.perdas}x)`} style={{ marginLeft: 5, color: "#b91c1c" }}><Icone nome="refazer" size={12} /></span>}
                  {o.div_pendentes > 0 && <span title="Divergência pendente" style={{ marginLeft: 5, color: "var(--vermelho)" }}><Icone nome="alerta" size={12} /></span>}
                  {o.div_total > 0 && o.div_pendentes === 0 && <span title="Divergência resolvida" style={{ marginLeft: 5, color: "var(--cinza)" }}><Icone nome="alerta" size={12} /></span>}
                </td>
                <td>{o.cliente}</td>
                <td>{o.loja_nome}</td>
                <td>{o.vendedor || '—'}</td>
                <td>{o.lente || '—'}</td>{u.perfil !== 'atendente' && <td style={{ fontWeight: 700 }}>{o.numero_pedido || '—'}</td>}
                <td style={{ fontWeight: 700 }}>{o.caixa || '—'}</td>
                <td>{o.cancelada
                  ? <span className="badge" style={{ background: '#eef1f2', color: 'var(--cinza)' }}>Cancelada</span>
                  : <span className="badge" style={{ background: ST_COR[o.status] + '22', color: ST_COR[o.status] }}>{ST_LABEL[o.status]}</span>}</td>
                <td style={{ fontWeight: 700, color: o.dias >= diasAtraso && o.status !== 'recebido_loja' && !o.cancelada ? 'var(--vermelho)' : 'var(--cinza)' }}>{o.dias}d</td>
              </tr>
            ))}
            {!lista.length && <tr><td colSpan={u.perfil !== 'atendente' ? 9 : 8} style={{ textAlign: 'center', color: 'var(--cinza)' }}>Nenhuma OS encontrada.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
